import AllRoutes from "./Component/AllRoutes";
import Navbar from "./Component/Navbar";


function App() {
  return (
    <div className="App">
    <Navbar></Navbar>
   <AllRoutes></AllRoutes>

    </div>
  );
}

export default App;
